module.exports = __webpack_public_path__ + "fonts/Graphik-Bold.e78d3d4.otf";